<script setup>
import {inject, ref} from "vue";

import useGrid from "@/composables/useGrid";
import trackersCompaniesService from "@/services/trackers-companies.service";
import TablePager from "@/components/TablePager.vue";
import StartupPlate from "@/components/trackers/StartupPlate.vue";
const {gridParams, gridMethods, items} = useGrid(getStartups, 9);

const trackerId = inject('tracker').value.id;
const openChat = inject('openChat');

const showModal = ref(false);

async function getStartups(pageParams) {
    return trackersCompaniesService.getUnappliedStartups(trackerId, pageParams);
}

function open() {
    gridMethods.loadIfNotLoaded();
    showModal.value = true;
}

function sendMessage(startupId) {
    openChat(startupId);
    showModal.value = false;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" title="Unapplied Startups" hide-footer modal-class="modal-unapplied">
        <div class="card-list">
            <StartupPlate
                v-for="(item, index) in items"
                :key="index"
                :startup="item"
                :unapplied="true"
                @sendMessage="sendMessage(item.id)"
            />
        </div>

        <TablePager
            v-if="items.length"
            :pages-count="gridParams.pagesCount"
            :init-page="gridParams.currentPage"
            @changePage="gridMethods.changePage"
        />
    </b-modal>
</template>

<style scoped>

</style>
